<ng-template #emailChips let-emails="emails" let-onRemove="onRemove" let-onEdit="onEdit" let-onSave="onSave"
  let-chipType="chipType" let-editable="editable">
  @if (emails.length > 0) {
    <div class="email-chips">
      @for (email of emails; track trackByIndex($index)) {
        <span class="email-chip" [title]="email">
          @if (editable && editingChip?.email === email && editingChip?.type === chipType) {
            <input type="text"
              class="chip-edit-input" [value]="email" #editInput (blur)="onSave(email, editInput.value)"
              (keyup.enter)="onSave(email, editInput.value)" (keyup.escape)="cancelEditRecipient()" autofocus>
          }
          @if (!(editable && editingChip?.email === email && editingChip?.type === chipType)) {
            <span
              class="email-text" [ngClass]="{'editable': editable}"
            (dblclick)="editable && onEdit ? onEdit(email) : null">{{ email }}</span>
          }
          <i class="fas fa-times" (click)="onRemove(email)"></i>
        </span>
      }
    </div>
  }
</ng-template>

<ng-template #employeeOption let-emp>
  <div class="select-option">
    <div class="option-row">
      <div class="cell">{{ emp.name || '-' }}</div>
      <div class="cell">{{ emp.organizationLevelName || '-' }}</div>
      <div class="cell">{{ emp[employeeTypeProperty] || '-' }}</div>
      <div class="cell">{{ employeeFullNameById.get(emp.id) || '-' }}</div>
      <div class="cell">{{ emp[emailProperty] || '-' }}</div>
      <div class="cell">{{ emp[positionProperty] || '-' }}</div>
    </div>
  </div>
</ng-template>

<ng-template #employeeDropdown let-selectedId="selectedId" let-filteredList="filteredList" let-searchTerm="searchTerm"
  let-onSelectionChange="onSelectionChange" let-onSearchChange="onSearchChange" let-labelText="labelText"
  let-placeholderText="placeholderText" let-getDisplayFn="getDisplayFn" let-showClearButton="showClearButton"
  let-onClear="onClear" let-onAdvancedSearch="onAdvancedSearch" let-onScroll="onScroll"
  let-isLoadingMore="isLoadingMore">
  <div class="position-relative">
    <mat-form-field appearance="outline" class="search-extended">
      <mat-label>{{ labelText | translate }}</mat-label>
      <mat-select [ngModel]="selectedId" (selectionChange)="onSelectionChange($event.value)"
        panelClass="multiple-select-panel" (openedChange)="$event && attachScrollListener($event)">

        <mat-select-trigger>
          {{ getDisplayFn() || (placeholderText | translate) }}
        </mat-select-trigger>

        <mat-option>
          <ngx-mat-select-search [ngModel]="searchTerm" placeholderLabel="{{ 'Search' | translate }}..."
            (ngModelChange)="onSearchChange($event)">
          </ngx-mat-select-search>
        </mat-option>

        <mat-option disabled class="static-option-header">
          <div class="select-option header">
            <div class="option-row">
              <div class="cell"><strong>Id</strong></div>
              <div class="cell"><strong>{{'Organization Level' | translate}}</strong></div>
              <div class="cell"><strong>{{'Employee Type' | translate}}</strong></div>
              <div class="cell"><strong>{{'Full Name' | translate}}</strong></div>
              <div class="cell"><strong>{{'Email' | translate}}</strong></div>
              <div class="cell"><strong>{{'Position' | translate}}</strong></div>
            </div>
          </div>
        </mat-option>

        @for (emp of filteredList; track trackById($index, emp)) {
          <mat-option [value]="emp.id">
            <ng-container *ngTemplateOutlet="employeeOption; context: {$implicit: emp}"></ng-container>
          </mat-option>
        }

        @if (isLoadingMore) {
          <mat-option disabled>
            <div class="loading-more">
              <mat-spinner diameter="20"></mat-spinner>
              <span>{{'Loading more' | translate}}...</span>
            </div>
          </mat-option>
        }

        @if (!filteredList.length && !isLoadingMore) {
          <mat-option disabled>
            {{ 'No options found' | translate }}
          </mat-option>
        }
      </mat-select>

      @if (showClearButton) {
        <button mat-icon-button matSuffix tabindex="-1"
          (click)="onClear(); $event.stopPropagation()" aria-label="Clear selection">
          <mat-icon>close</mat-icon>
        </button>
      }
    </mat-form-field>

    <div class="extended-search-icon" (click)="onAdvancedSearch()" title="Open advanced search">
      <span class="material-symbols-outlined">search</span>
    </div>
  </div>
</ng-template>

@if (isVisible) {
  <div class="popup-overlay" (click)="onOutsideClick()">
    <div class="popup-container" [class.popup-container--edit-mode]="isEditMode" (click)="$event.stopPropagation()">
      <div class="popup-header" [class.popup-header--edit-mode]="isEditMode">
        <h2><mat-icon class="popup-header__icon">description</mat-icon> {{ (isLetter ? 'Generate Letter' : 'Generate Report') | translate }}</h2>
        @if (isEditMode) {
          <span class="edit-mode-badge edit-mode-badge--centered">
            <mat-icon class="edit-mode-badge__icon">edit</mat-icon> {{ 'Editing Template' | translate }}
          </span>
        }
        <button class="close-btn" (click)="onOutsideClick()">
          <i class="fas fa-times"></i>
        </button>
      </div>
      @if (exemptedSamples?.length) {
        <div class="sample-exemption-alert">
          <div class="sample-exemption-alert__summary d-flex align-items-center">
            <span><mat-icon>warning</mat-icon></span>
            <div class="sample-exemption-alert__text">
              <b>{{ exemptedSamplesSummary }}</b> - {{ 'not in Approved or Approved Letter Sent status' | translate }}
            </div>
            <button type="button" class="sample-exemption-alert__toggle" (click)="toggleExemptedSamplesExpanded()">
              {{ (isExemptedSamplesExpanded ? 'Hide list' : 'Show list') | translate }}
              <mat-icon>{{ isExemptedSamplesExpanded ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </div>
          @if (isExemptedSamplesExpanded) {
            <div class="sample-exemption-alert__details">
              {{ formattedExemptedSampleNumbers }}
            </div>
          }
        </div>
      }
      <div class="popup-content" [class.email-mode]="isEmailMode && !isEditMode">
        @if (isWaitingForData) {
          <app-rings-loader></app-rings-loader>
        }
        @if (isLoading && !isWaitingForData) {
          <div class="popup-generating-overlay">
            <mat-spinner diameter="48"></mat-spinner>
            <p class="popup-generating-overlay__label">{{ (isLetter ? 'Generating letter...' : 'Generating report...') | translate }}</p>
          </div>
        }
        @if (!isWaitingForData) {
          <div class="left-panel"
            [class.full-width]="isEmailMode && !isEditMode"
            [class.left-panel--edit-mode]="isEditMode"
            [class.left-panel--collapsed]="isEditMode && leftPanelCollapsed"
            [class.filters-locked]="isEditMode && !leftPanelCollapsed">
            @if (isEditMode) {
              <button class="left-panel__toggle"
                (click)="toggleLeftPanel()"
                [title]="(leftPanelCollapsed ? 'Expand Sidebar' : 'Collapse Sidebar') | translate">
                <mat-icon>{{ leftPanelCollapsed ? 'chevron_right' : 'chevron_left' }}</mat-icon>
              </button>
            }
            @if (isEditMode && leftPanelCollapsed) {
              <span class="left-panel__vertical-label">
                {{ 'Filters' | translate }}
              </span>
            }
            @if (!leftPanelCollapsed || !isEditMode) {
              <div class="left-panel__content">
                @if (isEditMode) {
                  <div class="filters-lock-banner filters-lock-banner--info">
                    <mat-icon class="filters-lock-banner__icon">lock</mat-icon>
                    <span>{{ 'Filters locked while editing. Save or discard to unlock.' | translate }}</span>
                  </div>
                }
                @if (isEmailMode) {
                  <div class="email-form-section">
                    <h3 class="section-title">
                      <i class="fas fa-envelope"></i> {{ (isLetter ? 'Send Letter' : 'Send Report') | translate }}
                    </h3>
                    <div class="form-group compact">
                      <label class="form-label">{{ 'Recipient\'s Email' | translate }}</label>
                        <ng-container *ngTemplateOutlet="employeeDropdown; context: {
                            selectedId: selectedEmployeeId,
                            filteredList: filteredEmployees,
                            searchTerm: employeeSearchTerm,
                            onSelectionChange: onEmployeeSelected.bind(this),
                            onSearchChange: filterEmployeesLocally.bind(this),
                            labelText: 'Search Employee',
                            placeholderText: 'Search Employee',
                            getDisplayFn: getSelectedEmployeeDisplay.bind(this),
                            showClearButton: hasSelectedEmployee,
                            onClear: clearSelectedEmployee.bind(this),
                            onAdvancedSearch: openEmployeeSearchDialog.bind(this, false),
                            onScroll: onEmployeeDropdownScroll.bind(this),
                            isLoadingMore: isLoadingMoreEmployees
                        }"></ng-container>
                    </div>
                    <div class="form-group compact">
                      <label class="form-label">CC</label>
                        <ng-container *ngTemplateOutlet="employeeDropdown; context: {
                            selectedId: selectedCcEmployeeId,
                            filteredList: filteredCcEmployees,
                            searchTerm: ccEmployeeSearchTerm,
                            onSelectionChange: onCcEmployeeSelected.bind(this),
                            onSearchChange: filterCcEmployeesLocally.bind(this),
                            labelText: 'Search Employee for CC',
                            placeholderText: 'Search Employee for CC',
                            getDisplayFn: getSelectedCcEmployeeDisplay.bind(this),
                            showClearButton: false,
                            onClear: null,
                            onAdvancedSearch: openEmployeeSearchDialog.bind(this, true),
                            onScroll: onEmployeeDropdownScroll.bind(this),
                            isLoadingMore: isLoadingMoreEmployees
                        }"></ng-container>
                      <div class="input-with-button mt-2">
                        <input type="text" class="form-input" [(ngModel)]="ccRecipientInput"
                          (keyup.enter)="addCcRecipient()" [placeholder]="'Enter email manually' | translate"
                          autocomplete="off">
                          <button class="add-btn" (click)="addCcRecipient()" [disabled]="!ccRecipientInput?.trim()"
                            title="{{ 'Add CC recipient' | translate }}">
                            <i class="fas fa-plus"></i>
                          </button>
                        </div>
                        <ng-container *ngTemplateOutlet="emailChips; context: {
                            emails: ccRecipients,
                            onRemove: removeCcRecipient.bind(this),
                            onEdit: editCcRecipient.bind(this),
                            onSave: saveCcRecipient.bind(this),
                            chipType: 'cc',
                            editable: true
                        }"></ng-container>
                      </div>
                      <div class="form-group compact">
                        <div class="form-label-with-counter">
                          <label class="form-label">{{ 'Subject' | translate }}</label>
                          <span class="char-counter" [class.limit-reached]="emailSubject?.length >= 500">
                            {{ emailSubject?.length || 0 }}/500
                          </span>
                        </div>
                        <input type="text" class="form-input" [(ngModel)]="emailSubject"
                          [placeholder]="'Enter Subject' | translate" maxlength="500">
                        </div>
                        <div class="form-group compact">
                          <label class="form-label">{{ 'Attachment' | translate }}</label>
                          <div class="attachment-display">
                            <i class="fas fa-paperclip attachment-icon"></i>
                            <span class="attachment-name">{{ getAttachmentFilename() }}</span>
                          </div>
                        </div>
                        <div class="form-group compact">
                          <label class="form-label">{{ 'Message' | translate }}</label>
                          <app-rich-text-editor [(ngModel)]="emailMessage" [placeholder]="'Enter Message' | translate"
                            minHeight="300px" maxHeight="calc(100vh - 500px)">
                          </app-rich-text-editor>
                        </div>
                        @if (emailValidationMessages.length > 0) {
                          <div class="validation-messages">
                            @for (message of emailValidationMessages; track trackByIndex($index)) {
                              <div class="validation-error">
                                <i class="fas fa-exclamation-circle"></i> {{ message }}
                              </div>
                            }
                          </div>
                        }
                        @if (emailWarningMessages.length > 0 && canSendEmail) {
                          <div class="validation-messages">
                            @for (warning of emailWarningMessages; track trackByIndex($index)) {
                              <div class="validation-warning">
                                <i class="fas fa-exclamation-triangle"></i> {{ warning }}
                              </div>
                            }
                          </div>
                        }
                        <button class="btn save-modal-btn send-email-btn" [disabled]="!canSendEmail" (click)="sendEmail()">
                          <i class="fas fa-paper-plane"></i> {{ 'Send' | translate }}
                        </button>
                      </div>
                    }
                    @if (!isEmailMode) {
                      <div class="section">
                        <h3><i class="fas fa-file-alt"></i> {{ 'Template Selection' | translate }}</h3>
                        <app-list-filter-toolbar class="template-filter-toolbar"
                          [searchPlaceholder]="'Search Templates'"
                          (filterChange)="onListFilterChange($event)">
                        </app-list-filter-toolbar>
                        @if (hasTemplates) {
                          <div class="template-list">
                            @for (template of filteredTemplates; track trackByTemplateId($index, template)) {
                              <div class="template-item"
                                [class.selected]="selectedTemplate?.id === template.id"
                                (click)="selectTemplate(template)">
                                <div class="template-item__leading">
                                  @if (template.isDefault) {
                                    <mat-icon class="template-item__icon">lock</mat-icon>
                                  }
                                  @if (!template.isDefault && template.isShared) {
                                    <mat-icon class="template-item__icon template-item__icon--shared">group</mat-icon>
                                  }
                                  @if (!template.isDefault && !template.isShared) {
                                    <mat-icon class="template-item__icon template-item__icon--private">person</mat-icon>
                                  }
                                </div>
                                <div class="template-info">
                                  <div class="template-name">{{ template.name }}</div>
                                  <div class="template-meta">{{ template.entityTypeLabel }}</div>
                                </div>
                                <div class="template-stamps">
                                  @if (template.isDefault) {
                                    <span class="template-stamp template-stamp--default">
                                      {{ 'Default' | translate }}
                                    </span>
                                  }
                                  @if (!template.isDefault && !template.canManage && template.isShared) {
                                    <span class="template-stamp template-stamp--readonly">
                                      {{ 'Shared · read-only' | translate }}
                                    </span>
                                  }
                                </div>
                              </div>
                            }
                          </div>
                        }
                        @if (!hasTemplates) {
                          <div class="no-templates">
                            <i class="fas fa-exclamation-triangle"></i>
                            <p>{{ (isLetter ? 'No letter templates available' : 'No report templates available') | translate }}</p>
                          </div>
                        }
                      </div>
                      <div class="section">
                        <h3>
                          <i class="fas fa-filter"></i> {{'Data Filters' | translate}}
                          @if (hasPendingChanges) {
                            <span class="pending-indicator">
                              <i class="fas fa-clock text-warning"></i>
                              {{'Pending Changes' | translate}}
                            </span>
                          }
                        </h3>
                        @switch (filterState) {
                          @case ('no-template') {
                            <div class="no-filters">
                              <div class="info-message">
                                <mat-icon class="info-message__icon">article</mat-icon>
                                <p><strong>{{'Select template to filter data' | translate}}</strong></p>
                                <p>{{'Choose a template first to see available filters' | translate}}</p>
                              </div>
                            </div>
                          }
                          @case ('no-filters') {
                            <div class="no-filters">
                              <div class="info-message">
                                <mat-icon class="info-message__icon">info_outline</mat-icon>
                                <p><strong>{{(isLetter ? 'For this letter you cannot filter data' : 'For this report you cannot filter data') | translate}}</strong></p>
                                <p>{{'This' | translate}} {{entityType}} {{'has insufficient data for filtering' |
                                translate}}</p>
                              </div>
                            </div>
                          }
                          @case ('filters-available') {
                            <div class="filters-list">
                              <mat-accordion [multi]="true" class="filter-groups">
                                @for (filter of availableFilters; track trackByIndex($index)) {
                                  <mat-expansion-panel class="filter-group"
                                    [expanded]="expandedFilterPaths.has(filter.path)"
                                    (opened)="onFilterPanelToggle(filter.path, true)"
                                    (closed)="onFilterPanelToggle(filter.path, false)">
                                    <mat-expansion-panel-header>
                                      <mat-panel-title class="filter-group__title">
                                        <span class="filter-group__label">{{ filter.label | translate}}</span>
                                        @if (changedFilterPaths.has(filter.path)) {
                                          <span class="changed-indicator"
                                            [title]="'This filter has unsaved changes' | translate">
                                            <i class="fas fa-circle"></i>
                                          </span>
                                        }
                                      </mat-panel-title>
                                      <mat-panel-description class="filter-group__summary">
                                        {{ filterSelectableCounts.get(filter.path) }} · {{ filterSelectionSummaries.get(filter.path) }}
                                      </mat-panel-description>
                                    </mat-expansion-panel-header>
                                    <div class="filter-options">
                                    @for (option of filter.availableValues; track trackByIndex($index)) {
                                      <label class="filter-option"
                                        [class.disabled]="lastSelectedFilterValues.get(filter.path) === option.value || option.disabled">
                                        <input type="checkbox" [value]="option.value"
                                          [checked]="filter.selectedValues.includes(option.value)"
                                          [disabled]="option.disabled"
                                          (change)="toggleFilterValue(filter, option.value); onFilterChange()" />
                                          <span class="checkmark"></span>
                                          <div class="option-info">
                                            <span class="option-label">{{ option.label }}</span>
                                            <span class="option-count">({{ option.count }})</span>
                                            @if (lastSelectedFilterValues.get(filter.path) === option.value) {
                                              <span class="required-indicator"
                                                >
                                                {{'*at least 1 required' | translate}}
                                              </span>
                                            }
                                          </div>
                                        </label>
                                      }
                                    </div>
                                  </mat-expansion-panel>
                                }
                              </mat-accordion>
                                @if (hasPendingChanges && !hasUserInputs && !isEditMode) {
                                  <div class="input-actions">
                                    <button class="btn cancel-modal-btn" (click)="discardAllChanges()"
                                      [title]="'Discard changes and revert' | translate">
                                      <i class="fas fa-times"></i> {{'Discard' | translate}}
                                    </button>
                                    <button class="btn save-modal-btn" (click)="applyAllChanges()"
                                      [title]="'Apply changes and update preview' | translate">
                                      <i class="fas fa-check"></i> {{'Apply Changes' | translate}}
                                    </button>
                                  </div>
                                }
                              </div>
                            }
                          }
                        </div>
                        @if (hasUserInputs) {
                          <div class="section">
                            <h3>
                              <i class="fas fa-edit"></i>
                              {{(isLetter ? 'Letter Customization' : 'Report Customization') | translate}}
                            </h3>
                            <div class="user-inputs">
                              @for (inputKey of userInputKeys; track trackByIndex($index)) {
                                <div class="input-group"
                                  >
                                  @if (selectedTemplate!.templateJson.declaredFields!.userInputs[inputKey].type === 'checkbox') {
                                    <label [for]="inputKey" class="checkbox-label">
                                      <input type="checkbox" [id]="inputKey" [(ngModel)]="pendingUserInputs[inputKey]"
                                        (change)="onUserInputChange()" class="checkbox-input"
                                        [class.pending-changes]="changedInputKeys.has(inputKey)">
                                        <span>{{
                                          selectedTemplate!.templateJson.declaredFields!.userInputs[inputKey].label
                                        }}</span>
                                        @if (changedInputKeys.has(inputKey)) {
                                          <span class="changed-indicator"
                                            [title]="'This field has unsaved changes' | translate">
                                            <i class="fas fa-circle"></i>
                                          </span>
                                        }
                                      </label>
                                    }
                                    @if (selectedTemplate!.templateJson.declaredFields!.userInputs[inputKey].type === 'text') {
                                      <label [for]="inputKey">
                                        {{ selectedTemplate!.templateJson.declaredFields!.userInputs[inputKey].label |
                                        translate }}
                                        @if (changedInputKeys.has(inputKey)) {
                                          <span class="changed-indicator"
                                            [title]="'This field has unsaved changes' | translate">
                                            <i class="fas fa-circle"></i>
                                          </span>
                                        }
                                      </label>
                                      <textarea [id]="inputKey" [(ngModel)]="pendingUserInputs[inputKey]"
                                        (input)="onUserInputChange()" class="input-field"
                                        [class.pending-changes]="changedInputKeys.has(inputKey)"
                                      [placeholder]="getInputPlaceholder(inputKey) | translate" rows="3"></textarea>
                                    }
                                  </div>
                                }
                                @if (hasPendingChanges && !isEditMode) {
                                  <div class="input-actions">
                                    <button class="btn cancel-modal-btn" (click)="discardAllChanges()"
                                      [title]="'Discard changes and revert' | translate">
                                      <i class="fas fa-times"></i> {{'Discard' | translate}}
                                    </button>
                                    <button class="btn save-modal-btn" (click)="applyAllChanges()"
                                      [title]="'Apply changes and update preview' | translate">
                                      <i class="fas fa-check"></i> {{'Apply Changes' | translate}}
                                    </button>
                                  </div>
                                }
                              </div>
                            </div>
                          }
                        }
                      </div>
                    }
                  </div>
                }
                @if (isEditMode && editorConfig && !isWaitingForData) {
                  <div class="right-panel rte-editor-container">
                    <app-report-template-editor
                      [config]="editorConfig"
                      (event)="onEditorEvent($event)">
                    </app-report-template-editor>
                    @if (isPdfPreviewLoading) {
                      <div class="editor-pdf-loading-overlay">
                        <mat-spinner diameter="48"></mat-spinner>
                        <p class="editor-pdf-loading-overlay__label">{{ 'Generating PDF...' | translate }}</p>
                      </div>
                    }
                  </div>
                }
                @if (!isEditMode && !isWaitingForData && !isEmailMode) {
                  <div class="right-panel" [class.right-panel--pdf-mode]="previewType === PreviewType.Pdf">
                    <div class="section">
                      <h3>
                        <i class="fas fa-file"></i>
                        {{(isLetter ? 'Letter Preview' : 'Report Preview') | translate}}
                        <div class="preview-header-actions">
                          @if (canEditTemplate) {
                            <button class="btn edit-template-btn"
                              [disabled]="isPreviewLoading"
                              (click)="requestEditMode()"
                              [title]="'Edit template layout' | translate">
                              <mat-icon class="preview-header-icon">mode_edit</mat-icon> {{'Edit template' | translate}}
                            </button>
                          }
                        </div>
                      </h3>
                      <div class="preview-container" #previewContainer>
                        @if (previewType === PreviewType.Pdf && pdfPreviewUrl) {
                          <iframe [src]="pdfPreviewUrl"
                          (load)="onPdfPreviewRendered($event)" class="pdf-preview-frame"></iframe>
                        }
                        @if (!isPreviewLoading && !pdfPreviewUrl) {
                          <div class="preview-static-content">
                            @if (previewType === PreviewType.Html && reportPreview) {
                              <div class="html-preview-content"
                              [innerHTML]="reportPreview"></div>
                            }
                            @if (!reportPreview && !pdfPreviewUrl) {
                              <div class="no-preview">
                                <mat-icon class="no-preview__icon">article</mat-icon>
                                <p>{{'Select a template to see preview' | translate}}</p>
                              </div>
                            }
                          </div>
                        }
                        @if (isPreviewLoading) {
                          <div class="preview-loading-overlay">
                            <mat-spinner diameter="48"></mat-spinner>
                            <p class="preview-loading-overlay__label">{{ 'Generating {{type}} preview...' | translate:{ type: (previewType === PreviewType.Pdf ? 'PDF' : 'HTML') } }}</p>
                          </div>
                        }
                      </div>
                    </div>
                  </div>
                }
              </div>
              @if (!isEditMode) {
                <div class="popup-footer">
                  @if (!isEmailMode) {
                    <div class="footer-info">
                      @if (selectedTemplate) {
                        <span>
                          {{'Template' | translate}}: <strong>{{ selectedTemplate.name }}</strong>
                        </span>
                      }
                      @if (availableFilters.length) {
                        <span>
                          {{'Filters applied' | translate}}: <strong>{{ getAppliedFiltersCount() }}</strong>
                        </span>
                      }
                    </div>
                  }
                  <div class="footer-actions">
                    @if (isEmailMode) {
                      <button class="btn cancel-modal-btn" (click)="onClose()">
                        <i class="fas fa-times"></i> {{ 'Cancel' | translate }}
                      </button>
                    }
                    @if (!isEmailMode) {
                      <button class="btn cancel-modal-btn" [disabled]="isLoading" (click)="onClose()">
                        <i class="fas fa-times"></i> {{ 'Cancel' | translate }}
                      </button>
                      <button class="btn save-modal-btn" [disabled]="!canGenerateReport" (click)="openSendEmailDialog()">
                        <i class="fas fa-envelope"></i> {{ 'Generate & Send Email' | translate }}
                      </button>
                      <button class="btn save-modal-btn" [disabled]="!canGenerateReport"
                        (click)="onGenerateReportForNewTab()">
                        <i class="fas fa-external-link-alt"></i> {{ (isLetter ? 'Generate & Open Letter' : 'Generate & Open Report') | translate }}
                      </button>
                    }
                  </div>
                </div>
              }
            </div>
          </div>
        }